/*=========================================================================================
  File Name: module-config-getters.js
  Description: Config Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	ConfigInfo: function(state) {
		return state.ConfigInfo;
	},
	CurrentDate: function(state) {
		return state.ConfigInfo.CurrentDate;
	},
	IsRulesForIndividual: function(state) {
		return (
			state.ConfigInfo &&
			state.ConfigInfo.HkdConfig &&
			state.ConfigInfo.HkdConfig.IsRulesForIndividual
		);
	},
	IsRequireSignDec: function(state) {
		return (
			state.ConfigInfo &&
			state.ConfigInfo.HkdConfig &&
			state.ConfigInfo.HkdConfig.IsRequireSignDec
		);
	},
	GdtServiceCodeDvcList: function(state) {
		return (
			state.ConfigInfo &&
			state.ConfigInfo.GdtServiceCodeDvcList
		) || [];
	},
	IsTaxReturnRegistrationForDvc: function(state) {
		return (
			state.ConfigInfo &&
			state.ConfigInfo.IsTaxReturnRegistrationForDvc
		) || false;
	},
	IsSendRegistrationServiceDvc: function(state) {
		return (
			state.ConfigInfo &&
			state.ConfigInfo.IsSendRegistrationServiceDvc
		) || false;
	},
	IsEnableAmisFlow: function(state) {
		return (
			state.ConfigInfo &&
			state.ConfigInfo.IsEnableAmisFlow
		) || false;
	},
};
